module.exports = __webpack_public_path__ + "static/media/bg-tab-popup-active.d507d697.png";